// Fullscreen triangle generated from gl_VertexID — no vertex buffers needed.
// Drawing 3 vertices covers the whole clip space; the fragment shader does all
// the work.
export const TOPO_VERTEX_SHADER = /* glsl */ `#version 300 es
void main() {
  vec2 pos = vec2(
    float((gl_VertexID << 1) & 2),
    float(gl_VertexID & 2)
  );
  gl_Position = vec4(pos * 2.0 - 1.0, 0.0, 1.0);
}
`;
